<div
  class="wrapper"
  [class.type-received]="type() === 'received'"
  [class.type-sent]="type() === 'sent'"
  [class.from-you]="sentFromYou()"
  [class.has-message-body]="messageText()"
  [class.no-message-body]="!messageText()"
  [class.no-date-time]="!messageMetadata() || isTyping()"
>
  @if (shouldShowProfilePic()) {
    <div class="sender-info">
      <div class="profile-picture">
        <glxy-avatar
          [src]="this.profilePicUrl()"
          [svgIcon]="this.profileSVGIcon()"
          [width]="28"
          [name]="messageFrom()"
          [matTooltip]="messageFrom()"
          [backgroundColor]="profileBackgroundColor()"
        />
        @if (profileSourceIconUrl()) {
          <div class="profile-source-icon" [style.background-image]="profileSourceIconCSS()"></div>
        }
      </div>
    </div>
  }

  <div class="message">
    @switch (isTyping()) {
      @default {
        <div class="chat-bubble" [innerHTML]="messageText()"></div>
        <div class="attachment">
          <ng-content />
        </div>
        <div class="sent-time" [innerHTML]="messageMetadata()"></div>
      }
      @case (true) {
        <div class="chat-bubble">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      }
    }
  </div>
</div>
